import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { FaEye, FaEdit, FaTrash,FaPlus } from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../redux/features/modalSlice";
import { setCategoryFilters } from '../../redux/features/filtersSlice';
import SearchBar from "../../common/Search";
import Pagination from "../../common/Pagination";
// import { useGetCategoriesQuery, useDeleteCategoryMutation, useChangeCategoryStatusMutation } from "../../redux/services/categoriesService/categories.Services";
import { useGetProductQuery } from "../../redux/services/productService/product.Services";
function ProductList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filters = useSelector((state) => state.filters.category);
  const { data, isLoading, isError } = useGetProductQuery(filters);
  const categories = data?.data || [];
  // const [deleteCategory] = useDeleteCategoryMutation();
  // const [changeCategoryStatus] = useChangeCategoryStatusMutation();
      const [openMenuId, setOpenMenuId] = useState(null);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const pagination = data?.pagination || {};
  const totalPages = pagination?.totalPages || 0;
  const showPagination = totalPages > 1;
  const hasData = setCategoryFilters?.length > 0;
  const isActive = (status) => {
    return status === "active" || status === "Active" || status === 1 || status === true;
  };
  const handlePageChange = (page) => {
    dispatch(
      setCategoryFilters({
        page,
      })
    );
  };

  
    // 🔥 toggle dropdown + capture position
    const handleToggleMenu = (e, id) => {
      e.stopPropagation();
  
      const rect = e.currentTarget.getBoundingClientRect();
  
      setMenuPosition({
        top: rect.bottom + 5,
        left: rect.right - 100,
      });
  
      setOpenMenuId((prev) => (prev === id ? null : id));
    };
  const handleSearch = (value) => {
    dispatch(
      setCategoryFilters({
        search: value,
        page: 1,
      })
    );
  }
  if (isLoading) {
    return <h3>Loading...</h3>;
  }

  if (isError) {
    return <h3>Something went wrong</h3>;
  }

  return (
    <div>
      <div className="page-header-breadcrumb all_breadcrumb">
        <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
          <nav>
            <h4 className="fw-semibold">
              All Product List
            </h4>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">
                  Home
                </Link>
              </li>

              <li className="breadcrumb-item active">
                Product List
              </li>
            </ol>
          </nav>
        </div>
        <div className="page-title fw-semibold fs-18 mb-0">
          <button
            className="btn btn-primary"
            onClick={() => navigate("/create-product")}
          >
            + Add Product
          </button>
        </div>
        <div className="mb-3">
          <SearchBar
            search={filters.search}
            setSearch={handleSearch}
            placeholder="Search  Categories..."
          />
        </div>
      </div>
      <div className="st-wrapper-card">
        
        <div className="st-table-responsive">
          <table className="table st-custom-table align-middle mb-0">
            <thead>
              <tr>
                <th>Sr.no.</th>
                <th>Category</th>
                <th>Sub Category</th>
                <th>State</th>
                <th>City</th>
                <th>Location</th>
                <th>Title</th>
                <th>Description</th>
                <th>Price</th>
                <th>Guest</th>
                {/* <th>Bedroom</th> */}
                {/* <th>Bed</th> */}
                {/* <th>Bathroom</th> */}
                <th>Status</th>
                <th>Change Status</th>
                {/* <th>Rating</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((item, index) => (
                <tr key={item.id}>

                  <td>
                    {(index + 1) + (filters.page - 1) * filters.limit}
                  </td>

                  <td>{item.categoryName}</td>

                  <td>{item.subcatName}</td>

                  <td>{item.stateName}</td>

                  <td>{item.cityName}</td>

                  <td>{item.location}</td>

                  <td>{item.title}</td>

                  <td style={{ maxWidth: "200px" }}>
                    {item.description}
                  </td>

                  <td>₹ {item.price}</td>

                  <td>{item.guest}</td>

                  {/* <td>{item.bedroom}</td>

                  <td>{item.bed}</td>

                  <td>{item.bathroom}</td> */}

                  <td>
                    {item.status === "active" ||
                      item.status === 1
                      ? "Active"
                      : "Inactive"}
                  </td>
                  <td style={{ width: "150px" }}>
                    <div className="city-status-switch">

                      <input
                        type="checkbox"
                        id={`status-${item.id}`}
                        className="city-status-input"
                        checked={
                          item.status === "active" ||
                          item.status === 1
                        }
                        onChange={() =>
                          dispatch(
                            openModal({
                              type: "status-product",
                              title: "Change Product Status",
                              data: {
                                id: item.id,
                                title: item.title,
                                status: item.status,
                                apiUrl: "/product-status",
                                message: `You want to change status of ${item.title}`,
                              },
                            })
                          )
                        }
                      />

                      <label
                        htmlFor={`status-${item.id}`}
                        className="city-status-label"
                      >
                        <span className="city-status-ball"></span>
                        <span className="city-status-text">
                          {item.status === "active" ||
                            item.status === 1
                            ? "Active"
                            : "Inactive"}
                        </span>
                      </label>

                    </div>
                  </td>

                  {/* <td>{item.rating}</td> */}

                  {/* <td className="text-center d-flex">

                    <button
                      className="st-action-btn st-view-btn"
                      onClick={() =>
                        navigate(`/view-product/${item.id}`)
                      }
                    >
                      <FaEye />
                    </button>

                    <button
                      className="st-action-btn st-edit-btn"
                      onClick={() =>
                        navigate(`/update-product/${item.id}`)
                      }
                    >
                      <FaEdit />
                    </button>

                    <button
                      className="st-action-btn st-delete-btn"
                      onClick={() =>
                        dispatch(
                          openModal({
                            type: "delete-product",
                            title: "Delete Product",
                            data: {
                              id: item.id,
                              apiUrl: "/product-delete",
                              useBody: true,
                              message: `You are deleting ${item.title}`,
                            },
                          })
                        )
                      }
                    >
                      <FaTrash />
                    </button>


                    <button
                      className="st-action-btn st-view-btn"
                      onClick={() =>
                        navigate(`/add-product-images/${item.id}`, 
                         
                        )
                      }
                    >
                      <FaPlus />
                    </button>
                    <button
                      className="st-action-btn st-view-btn"
                      onClick={() =>
                        navigate(`/update-product-images/${item.id}`
                          // state: { product: item },
                        )
                      }
                    >
                      <FaEdit />
                    </button>
                    <button
                      className="st-action-btn st-view-btn"
                      onClick={() =>
                        navigate(`/view-product-images/${item.id}`
                        )}
                    >
                        <FaEye />
                    </button>
                   

                  </td> */}
      <td style={{ position: "relative" }}>
                    <button
                      className="btn btn-light btn-sm"
                      onClick={(e) =>
                        handleToggleMenu(e, item.id)
                      }
                    >
                      ⋮
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

  {openMenuId && (
            <ul
              className="action-menu"
              style={{
                position: "absolute",
                top: menuPosition.top,
                left: menuPosition.left,
                width: "150px",
                background: "#fff",
                zIndex: 9999,
                boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                borderRadius: "6px",
                padding: "6px 0",
                listStyle: "none",
              }}
            >
              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    navigate(`/view-product/${openMenuId}`)
                  }
                >
                  View Product
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    navigate(`/update-product/${openMenuId}`)
                  }
                >
                  Edit Product
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item text-danger"
                  onClick={() =>
                    dispatch(
                      openModal({
                        type: "delete-product",
                        data: {
                          id: openMenuId,
                          apiUrl: "/product-delete",
                        },
                      })
                    )
                  }
                >
                  Delete Product
                </button>
              </li>

             

              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    navigate(`/add-product-images/${openMenuId}`)
                  }
                >
                  Add Images
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    navigate(`/view-product-images/${openMenuId}`)
                  }
                >
                  View Images
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    navigate(`/update-product-images/${openMenuId}`)
                  }
                >
                  Update Images
                </button>
              </li>
            </ul>
          )}

          {/* OVERLAY */}
          {openMenuId && (
            <div
              onClick={() => setOpenMenuId(null)}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 9998,
              }}
            />
          )}


          <div className="d-flex justify-content-end mt-4">

            {showPagination && (
              <div className="d-flex justify-content-end mt-4">
                <Pagination
                  page={filters.page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}

          </div>
        </div>

      </div>
    </div>
  );
}

export default ProductList;